import React, {useCallback, useState} from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';

type Props = {
    componentClasses?: string;
    onDragStart?: () => void;
    onDragEnd?: () => void;
};

export const PinIcon = (props: Props) => {
    const {componentClasses = '', onDragEnd, onDragStart} = props;
    const [isDragging, setDrag] = useState(false);

    const onDragStartHandler = useCallback(
        e => {
            setDrag(true);
            onDragStart?.();
        },
        [setDrag, onDragStart]
    );

    const onDragEndHandler = useCallback(
        e => {
            setDrag(false);
            onDragEnd?.();
        },
        [onDragEnd]
    );

    return (
        <div className={componentClasses}>
            <div draggable="true" onDragStart={onDragStartHandler} onDragEnd={onDragEndHandler}>
                <Icon icon={isDragging ? PriorityIcon.pin : PriorityIcon.pinPinned} />
            </div>
        </div>
    );
};
